/* skin-select.js
   Whole tile clickable on desktop + mobile
   Prevent accidental opens while scrolling
   Makes saving images a bit harder
*/
(function () {
  var GRID_SELECTOR = '#product-grid';
  var TILE_SELECTOR = '.card-wrapper, .product-card-wrapper, .grid__item';
  var MOVE_PX = 14;

  function initSkinSelectGrid() {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    var startX = 0;
    var startY = 0;
    var moved = false;
    var touching = false;

    function getPoint(e) {
      if (e.touches && e.touches[0]) return e.touches[0];
      if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0];
      return e;
    }

    function getProductUrl(tile) {
      if (!tile) return null;

      var link =
        tile.querySelector('a[href*="/products/"]') ||
        tile.querySelector('.full-unstyled-link[href]') ||
        tile.querySelector('.full-width-link[href]') ||
        tile.querySelector('.card__heading a[href]');

      return link ? link.href : null;
    }

    grid.addEventListener(
      'touchstart',
      function (e) {
        var p = getPoint(e);
        startX = p.clientX;
        startY = p.clientY;
        moved = false;
        touching = true;
      },
      { passive: true }
    );

    grid.addEventListener(
      'touchmove',
      function (e) {
        if (!touching) return;
        var p = getPoint(e);

        if (
          Math.abs(p.clientX - startX) > MOVE_PX ||
          Math.abs(p.clientY - startY) > MOVE_PX
        ) {
          moved = true;
        }
      },
      { passive: true }
    );

    function endTouch() {
      setTimeout(function () {
        moved = false;
        touching = false;
      }, 0);
    }

    grid.addEventListener('touchend', endTouch, { passive: true });
    grid.addEventListener('touchcancel', endTouch, { passive: true });

    grid.addEventListener(
      'click',
      function (e) {
        var tile = e.target.closest && e.target.closest(TILE_SELECTOR);
        if (!tile || !grid.contains(tile)) return;

        var url = getProductUrl(tile);
        if (!url) return;

        var clickedFormControl =
          e.target.closest &&
          e.target.closest('button, input, select, textarea, summary, label');

        if (clickedFormControl) return;

        if (touching && moved) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        if (e.metaKey || e.ctrlKey) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.open(url, '_blank');
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = url;
      },
      true
    );

    /* Makes saving images harder */
    grid.addEventListener('contextmenu', function (e) {
      var hit =
        e.target.closest &&
        e.target.closest('img, picture, .media, .card__media');
      if (hit) e.preventDefault();
    });

    grid.addEventListener('dragstart', function (e) {
      var hit = e.target.closest && e.target.closest('img, picture');
      if (hit) e.preventDefault();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkinSelectGrid);
  } else {
    initSkinSelectGrid();
  }
})();
/* Prevent jump-to-top from empty hash links on mobile */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest && e.target.closest('a[href="#"], a[href=""], a[href="#!"]');
      if (!link) return;

      // Cancel the jump, but let controls such as the currency picker handle the click.
      e.preventDefault();
    },
    true
  );
})();
